import styled from 'styled-components';

export const EmailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const EmailRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .ui.input {
    width: 100%;
  }
`;





export const FilesSection = styled.div`
  margin-top: 30px;

  .required {
    color: red;
    margin-left: 4px;
  }
`;

export const FilesDescription = styled.div`
  margin: 10px 0 0px;
  font-size: 0.95em;

  strong {
    font-weight: bold;
  }
`;

export const FilesList = styled.div`
  display: flex;
  margin-bottom: 20px;
  background-color: #f2f2f2;
  border-radius: 5px;
  padding: 10px;

  .file-list-column {
    flex: 1;

    .file-item {
      margin-bottom: 10px;
      font-size: 0.9em;

      a {
        text-decoration: none;
        color: #333;
        text-decoration: underline;
        &:hover {
          color: #2185d0;
        }
      }
    }
  }
`;

export const ObservationsContainer = styled.div`
  textarea {
    width: 100%;
    padding: 12px 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    resize: vertical;
    outline: none;
  }
`;

export const Hr = styled.hr`
  border: none;
  height: 1px;
  background-color: #f2f2f2;
  margin-top: 3px;
  margin-bottom: 10px;
`;
